import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'building_guid': 'String!',
	'timeslot_guid': '[String]!',
};

export default gql(`
	mutation building_to_timeslot( ${ HelperGraphql.createFields( fields ) } ) {
	    building_to_timeslot( ${ HelperGraphql.createVariables( fields ) } ) {
	        building {
	            guid
	        }
	        
	        timeslot {
	            guid
	        }
	    }
	}
`);

